import NonEditableBlock from './base/non-editable-block';
import { computed } from '@ember/object';
import { hash, htmlEscape, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import openingTag from '@intercom/embercom-composer/lib/computed-properties/ic-block-opening-tag';
import uriComponentEncode from '@intercom/embercom-composer/lib/computed-properties/uri-component-encode';
import { not, or, alias } from '@ember/object/computed';
export default NonEditableBlock.extend({
  type: 'facebookLikeButton',
  isMedia: true,
  isFacebookLikeButton: true,
  isValid: true,
  isNotAllowSocial: not('config.allowSocial'),
  isLinkOnlyMode: or('isNotAllowSocial', 'config.displaySocialBlocksAsButtons'),
  blockUrl: alias('url'),
  openingTag: openingTag('url', 'id', 'isLinkOnlyMode'),
  closingTag: '</ic-block>',
  innerHtml: computed('_zeroWidthSpace', '_paragraphInserter', 'iframeOrLinkHtml', function () {
    return `${this._zeroWidthSpace}${this._paragraphInserter}<span contenteditable="false">${this.iframeOrLinkHtml}</span>${this._paragraphInserter}${this._zeroWidthSpace}`;
  }),
  iframeOrLinkHtml: ternaryToProperty('isLinkOnlyMode', 'linkHtml', 'iframeHtml'),
  iframeHtml: computed('iframeSrcHref', function () {
    return `<iframe src="https://www.facebook.com/plugins/like.php?href=${this.iframeSrcHref}" class="block-iframe" scrolling="no" frameborder="0" allowtransparency="true"></iframe>`;
  }),
  linkHtml: computed('htmlEsacepdUrl', function () {
    return `<a class="link-only-mode intercom-h2b-button" href="${this.htmlEsacepdUrl}"><i></i>Like us on Facebook</a>`;
  }),
  iframeSrcHref: computed('urlEncodedUrl', function () {
    return `${this.urlEncodedUrl}&amp;width&amp;layout=standard&amp;action=like&amp;show_faces=false&amp;height=35`;
  }),
  urlEncodedUrl: uriComponentEncode('url'),
  htmlEsacepdUrl: htmlEscape('url'),
  serialized: hash('type', 'url')
});